import React, { PropsWithChildren, useCallback } from 'react';
import { FormRenderProps } from 'react-final-form';

import { DocumentValues, InteractExtraValues, SignAction } from 'Interfaces/Document';

import SelectActionFormOptions from './SelectActionFormOptions';
import {
  SelectActionFormSendPage,
  SelectActionFormSignAndSendPage,
  SelectActionFormSignDocumentPage,
} from './SelectActionFormPages';

interface SelectActionFormFieldsProps extends FormRenderProps<DocumentValues> {
  selectedAction: SignAction;
  isChooseActionDisabled?: boolean;
  onActionSelected: (action: SignAction) => void;
  showFormTitle?: boolean;
}

const SelectActionFormFields = ({
  children,
  selectedAction,
  isChooseActionDisabled,
  showFormTitle = true,
  onActionSelected,
  handleSubmit,
  form,
}: PropsWithChildren<SelectActionFormFieldsProps>) => {
  const handleSetExtraValues = useCallback(
    (values: InteractExtraValues) => {
      if (values.signers) {
        form.change('signers', values.signers);
        form.change('isOrdered', values.isOrdered);
      }

      if (values.recipients) {
        form.change('recipients', values.recipients);
      }

      if (!values.signers && values.isOrdered !== undefined) {
        form.change('isOrdered', values.isOrdered);
      }
    },
    [form],
  );

  return (
    <form className="selectActionForm" onSubmit={handleSubmit}>
      <SelectActionFormOptions
        selectedAction={selectedAction}
        isChooseActionDisabled={isChooseActionDisabled}
        showFormTitle={showFormTitle}
        onSelect={onActionSelected}
      />

      <div className="selectActionForm__content">
        {selectedAction === SignAction.SignDocument && (
          <SelectActionFormSignDocumentPage
            key={SignAction.SignDocument}
            onSetExtraValues={handleSetExtraValues}
          />
        )}
        {selectedAction === SignAction.SignAndSend && (
          <SelectActionFormSignAndSendPage
            key={SignAction.SignAndSend}
            isChooseActionDisabled={isChooseActionDisabled}
            onSetExtraValues={handleSetExtraValues}
          />
        )}
        {selectedAction === SignAction.Send && (
          <SelectActionFormSendPage
            key={SignAction.Send}
            isChooseActionDisabled={isChooseActionDisabled}
            onSetExtraValues={handleSetExtraValues}
          />
        )}
      </div>

      {children}
    </form>
  );
};

export default SelectActionFormFields;
